import React from "react"
import PropTypes from "prop-types"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"

const ContentSplitter = ({
  node,
  resumeClassName,
  contentClassName,
  splitPoint,
}) => {
  if (typeof document !== `undefined`) {
    const parser = new DOMParser()
    let div = parser.parseFromString(node.body?.processed.trim(), "text/html")
    const style = domSelector("style", div)
    const link = domSelector("link", div)
    div = div.querySelectorAll("body")[0].children
    let resumeText = ""
    let contentText = ""
    let breakText = false
    for (let index = 0; index < div.length; index++) {
      if (breakText) {
        contentText += div[index].outerHTML
      } else {
        resumeText += div[index].outerHTML
        if (resumeText.length > splitPoint || resumeText.includes("<img")) {
          breakText = true
        }
      }
    }
    resumeText = link + style + resumeText
    return (
      <>
        {node.body?.summary ? (
          <>
            <div className={resumeClassName}>
              <ContentTransformer content={node.body.summary} />
            </div>
            {node.body?.processed ? (
              <div className={contentClassName}>
                <ContentTransformer content={node.body.processed} />
              </div>
            ) : null}
          </>
        ) : node.body?.processed ? (
          <>
            <div className={resumeClassName}>
              <ContentTransformer content={resumeText} />
            </div>
            <div className={contentClassName}>
              <ContentTransformer content={contentText} />
            </div>
          </>
        ) : null}
      </>
    )
  }
  return null
}

const domSelector = (selector, div) => {
  return div.querySelectorAll(selector).length > 0
    ? div.querySelectorAll(selector)[0].outerHTML
    : ""
}

ContentSplitter.propTypes = {
  node: PropTypes.object.isRequired,
  resumeClassName: PropTypes.object.isRequired,
  contentClassName: PropTypes.object.isRequired,
  splitPoint: PropTypes.number.isRequired,
}

export { ContentSplitter }
